import { Component } from '@angular/core';

import { PdfService } from '@app/ptrab/services';
import { ActionsAnalytics, CategoriesAnalytics } from '@app/services/analytics/models/analytics.enum';
import { BaseComponentDirective } from '@app/shared/bases/base.component';
import { AnalyticsService } from '@services/analytics/analytics.service';

@Component({
  selector: 'app-vacation-tools',
  templateUrl: './vacation-tools.component.html',
  styleUrls: ['./vacation-tools.component.scss']
})
export class VacationToolsComponent extends BaseComponentDirective {
  private isFetchingPdf!: boolean;

  constructor(private pdfService: PdfService, private analyticsService: AnalyticsService) {
    super();
  }

  downloadPDF() {
    if (this.isFetchingPdf) {
      return;
    }

    try {
      this.isFetchingPdf = true;
      this.analyticsService.sendEvent(CategoriesAnalytics.DOWNLOAD, {
        [ActionsAnalytics.DOWNLOAD]: ActionsAnalytics.HOLIDAYS
      });
      this.pdfService.fetchMOTVacationsPdf().then(() => {
        this.isFetchingPdf = false;
      });
    } catch {
      this.isFetchingPdf = false;
    }
  }
}
